import { useCarValuationToolContext } from '../../CarValuationTool.context';
import { useQueryParams } from '../../../../../../../hooks/UseQueryParams';

import { MODAL_QUERY } from '../../../../../../../components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal.constants';

/**
 * This hook is responsible for user vehicle interactions. A user may update their vehicle details
 * by opening the value car modal, or remove their current car from their profile.
 *
 * They may also offer their car as a trade-in. By executing the associated function, a query is added
 * to the URL which opens the dealer enquiry modal.
 *
 * @returns the function for opening the remove vehicle modal, the function for opening the value car modal,
 * and finally the function for updating the URL with the query used to open the dealer enquiry modal.
 */
const useUserVehicle = () => {
  const { setIsValueCarModalOpen, setIsRemoveUserVehicleModalOpen } =
    useCarValuationToolContext();

  const openRemoveUserVehicleModal = () =>
    setIsRemoveUserVehicleModalOpen(true);

  const updateVehicleDetails = () => {
    setIsValueCarModalOpen(true);
  };

  const { addQueries } = useQueryParams();

  const dealerEnquiryModalQuery = MODAL_QUERY;

  const openDealerEnquiryModal = () => addQueries(dealerEnquiryModalQuery);

  return {
    openRemoveUserVehicleModal,
    updateVehicleDetails,
    openDealerEnquiryModal,
  };
};

export { useUserVehicle };
